import Vue from 'vue';
import { has } from 'lodash';

import { handleError } from '@/utils/exception_handler';

// STATE
export const createState = {
  creating: false,
};

// GETTERS
export const createGetters = {
  creating: state => state.creating,
};

// MUTATIONS
export const buildCreateMutations = (mutationNames) => {
  const mutations = {};

  mutationNames.forEach((mutation) => {
    mutations[`${mutation}Pending`] = (state) => {
      Vue.set(state, 'creating', true);
    };

    mutations[`${mutation}Success`] = (state) => {
      Vue.set(state, 'creating', false);
    };

    mutations[`${mutation}Error`] = (state) => {
      Vue.set(state, 'creating', false);
    };
  });

  return mutations;
};

// ACTIONS
export const create = (context, { api, endpoint, params, mutation = null, successCallback = null, errorCallback = null }) => {
  const { commit, dispatch } = context;
  const mutationPrefix = mutation || endpoint;

  if (!has(api, endpoint)) throw new Error(`Endpoint ${endpoint} not found`);

  commit(`${mutationPrefix}Pending`, [params.data]);

  return api[endpoint](params)
    .then((response) => {
      dispatch('insert', { data: response.entity });

      commit(`${mutationPrefix}Success`);

      if (successCallback) successCallback(response);

      return { status: true, data: response };
    }, handleError(context, `${mutationPrefix}Error`, errorCallback))
    .catch(handleError(context, `${mutationPrefix}Error`, errorCallback));
};



// WEBPACK FOOTER //
// ./src/store/extensions/create.js